<template>
  <router-view />
</template>

<script>
import Vue from 'vue';

export default {
  name: 'App',
  beforeCreate() {
    // const plugin = document.createElement('script');
    // plugin.setAttribute(
    //   'src',
    //   'https://unpkg.com/@ungap/custom-elements@1.0.0/min.js',
    // );
    // plugin.setAttribute(
    //   'src',
    //   'https://dasa.accenture.com/hermes/messenger/1.2.1/hermes-messenger.js',
    // );
    // plugin.async = true;
    // document.head.appendChild(plugin);
  },
  mounted() {
    window.addEventListener('click', this.onClick);

    if (window.flutter_inappwebview) {
      window.addEventListener('message', (event) => {
        if (event.data === 'flutterCapturePort') {
          if (event.ports[0] != null) {
            [Vue.prototype.$flutterPort] = event.ports;
            Vue.prototype.$flutterPort.onmessage = (event1) => {
              try {
                const flutterObjectData = JSON.parse(event1.data);
                this.$root.$emit('flutter:fileCapture', flutterObjectData);
              } catch (e) {
                this.$root.$emit('flutter:barcodeCapture', event1.data);
              }
            };
          }
        }
      }, false);
    }
  },
  methods: {
    onClick() {
      if (window.flutter_inappwebview) {
        window.flutter_inappwebview.callHandler('userInteracts');
      }
    },
  },
};
</script>

<style lang="scss">
/* Global app styles */

html {
  overflow-y: auto !important;
}

/* change autocomplete styles in webkit browsers */
/* helper animation to handle browser autocomplete functionallity */
input, select, textarea {
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus {
    background-color: transparent !important;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 16px;
    transition: background-color 5000s ease-in-out 0s, font-family 5000s ease-in-out 0s;
    animation-name: onautofillstart;
  }

  &:not(:-webkit-autofill) {
    animation-name: onautofillcancel;
  }
}

@keyframes onautofillstart { from {} }
@keyframes onautofillcancel { from {} }
</style>
